<script lang="ts">
	import {
		lightPriorityDevForce,
		lightPriorityDevLayout,
		setLightPriorityDevForce,
		setLightPriorityDevLayout,
	} from 'src/stores/features/dev/light-priority-dev-state';
	import PriorityLayoutDevHud from 'src/components/Sidepanel/PriorityLayoutDevHud.svelte';
	import {
		LIGHT_PRIORITY_DEV_OPTIONS,
		LIGHT_PRIORITY_LAYOUT_DEV_OPTIONS,
		type LightPriorityDevForce,
		type LightPriorityDevLayout,
	} from 'src/helpers/light_priority_layout';

	const onSelect = (id: string) => {
		setLightPriorityDevForce(id as LightPriorityDevForce);
	};

	const onExtraSelect = (id: string) => {
		setLightPriorityDevLayout(id as LightPriorityDevLayout);
	};
</script>

<PriorityLayoutDevHud
	options={LIGHT_PRIORITY_DEV_OPTIONS}
	selectedId={$lightPriorityDevForce}
	idPrefix="light-priority-dev"
	extraOptions={LIGHT_PRIORITY_LAYOUT_DEV_OPTIONS}
	extraSelectedId={$lightPriorityDevLayout}
	extraGroupLabel="Layout"
	{onSelect}
	{onExtraSelect}
/>
